import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import Footer from "./components/Footer/Footer";
import AboutPage from "./components/AboutPage/AboutPage";
import RegisterPage from "./components/RegisterPage/RegisterPage";
import ProfilePage from "./components/ProfilePage/ProfilePage";
import WinnersPage from "./components/WinnersPage/WinnersPage";
import WinnersInterviews from "./components/WinnersInterviews/WinnersInterviews";
import AdminDashboard from "./components/AdminDashboard/AdminDashboard";
import JudgeDashboard from "./components/JudgeDashboard/JudgeDashboard";
import TermsAndConditionsPage from "./components/TermsAndConditionsPage/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import ResetPassword from './components/ResetPassword/ResetPassword';
import RegisterOfflinePage from './components/RegisterOfflinePage/RegisterOfflinePage';

const ProtectedRoute = ({ children, isAuthenticated }) => {
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  return children;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isJudge, setIsJudge] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");

    if (token) {
      setIsAuthenticated(true);
      setIsAdmin(role === "admin");
      setIsJudge(role === "judge");
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/about" element={<AboutPage />} />
          <Route
            path="/register"
            element={
              <RegisterPage
                setIsAuthenticated={setIsAuthenticated}
                setIsAdmin={setIsAdmin}
                setIsJudge={setIsJudge}
              />
            }
          />
          <Route
            path="/login"
            element={
              <RegisterPage
                setIsAuthenticated={setIsAuthenticated}
                setIsAdmin={setIsAdmin}
                setIsJudge={setIsJudge}
              />
            }
          />
          <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/reg-offline" element={<RegisterOfflinePage />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-dashboard"
            element={
              isAuthenticated && isAdmin ? <AdminDashboard /> : <Navigate to="/login" />
            }
          />
          <Route
            path="/judge-dashboard"
            element={
              isAuthenticated && isJudge ? <JudgeDashboard /> : <Navigate to="/login" />
            }
          />
          <Route path="/winners" element={<WinnersPage />} />
          <Route path="/WinnersInterviews" element={<WinnersInterviews />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
